module.exports = __webpack_public_path__ + "593c4f4eacfe706ba562c8bbb2e3ccf9.png";